import React from 'react';
import { useTranslation } from 'react-i18next';
import { Gamepad2, Shield, Cpu, Gauge } from 'lucide-react';

import { GameServerFeatures } from '../components/GameServerFeatures';
import { GameServerPlans } from '../components/GameServerPlans';

export function GameHostingPage() {
  const { t } = useTranslation();

  return (
    <div className="pt-16">

      {/* HEADER */}
      <div className="relative bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">
            {t('gameHosting.title')}
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            {t('gameHosting.subtitle')}
          </p>
        </div>
      </div>

      {/* FEATURES GRID */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-4 gap-8 mb-16">

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Gamepad2 className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('gameHosting.features.instantActivation.title')}
            </h3>
            <p className="text-gray-600">
              {t('gameHosting.features.instantActivation.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('gameHosting.features.ddos.title')}
            </h3>
            <p className="text-gray-600">
              {t('gameHosting.features.ddos.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Cpu className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('gameHosting.features.cpu.title')}
            </h3>
            <p className="text-gray-600">
              {t('gameHosting.features.cpu.description')}
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Gauge className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">
              {t('gameHosting.features.ping.title')}
            </h3>
            <p className="text-gray-600">
              {t('gameHosting.features.ping.description')}
            </p>
          </div>

        </div>

        <GameServerFeatures />
        <GameServerPlans />
      </div>
    </div>
  );
}
